module.exports = __webpack_public_path__ + "img/slide-4.85f25e69.jpeg";